<template>
  <div class="row selectVideo">
    <div class="col-lg-6 pr-4 pt-2 pl-5 col-xs-12">
      <div class="form-group mb-0 has-search">
        <span class="fa fa-search ml-2 mt-2 form-control-feedback"></span>
        <input
          type="text"
          v-model="search"
          v-on:keyup.enter="searchVideos"
          class="form-control no_border bg_grey"
          placeholder="Search"
        />
      </div>
      <div class="container-video">
        <sweetalert-icon icon="loading" v-if="load" />

        <span v-if="videos.length == 0 && !load">NÃO HÁ VÍDEOS</span>
        <div class="row mr-0 ml-0">
          <div
            v-for="(video, index) in videos"
            :key="index"
            class="mt-2 mb-2 col-lg-4 col-xs-12"
          >
            <div
              :class="{ selected_video: index == select ? true : false }"
              class="pointer"
              @click="videoCurrent(index)"
            >
              <div v-show="video.video">
                <img
                  :src="video.thumbnail"
                  :class="{
                    full: video.thumb != '/images/no_video.png',
                    no_video: video.thumb == '/images/no_video.png',
                  }"
                />
              </div>
              <div v-show="!video.video">
                <video-embed :src="video.iframe"></video-embed>
              </div>
              <p class="align-left f12 mt-0 mb-0">{{ video.name }}</p>
              <p class="align-left name_recruiter mt-0 mb-0">
                {{ video.recruiter_name }}
              </p>
              <p class="align-left name_recruiter f9 mt-0 mb-0">
                {{ video.created_at | moment("D/MM/Y") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <button @click="chooseVideo" class="btn btn-primary full">
        SELECIONAR VÍDEO
      </button>
    </div>
    <div
      class="col-lg-6 mr-0 col-xs-12 pr-5 pl-4"
      style="background-color: #414141"
    >
      <div v-if="videos.length != 0">
        <h2 class="color-white">{{ videos[select].name }}</h2>
        <video
          style="margin: 0px auto"
          id="video_current"
          v-if="videos.length != 0 && videos[select].video"
          controls
          controlslist="nodownload"
          class="full"
        >
          <source :src="videos[select].video" />
        </video>
        <video-embed
          v-if="videos.length != 0 && videos[select].iframe != ''"
          :src="videos[select].iframe"
        ></video-embed>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "question", "gallery_item", "gallery", "intern"],
  data: () => ({
    src_selected: "",
    search: "",
    videos: [],
    load: false,
    select: 0,
  }),
  mounted() {
    this.searchVideos();
  },
  methods: {
    videoCurrent(index) {
      if (this.videos.length) {
        this.select = index;
        let video = document.getElementById("video_current");
        video.load();
      }
    },
    searchVideos() {
      this.load = true;
      let params = {
        search: this.search == "" ? "*" : this.search,
      };
      if (this.question) {
        axios
          .get("/recruiters/gallery_videos", { params: params })
          .then((response) => {
            this.intern == true
              ? (this.videos = response.data.videos_intern)
              : (this.videos = response.data.videos);
            this.videoCurrent(0);
            this.load = false;
            return;
          })
          .catch((err) => {
            this.load = false;
          });
      } else {
        axios
          .get("/recruiters/galleries/items/search", { params: params })
          .then((response) => {
            this.intern == true
              ? (this.videos = response.data.videos_intern)
              : (this.videos = response.data.videos);
            this.load = false;
          })
          .catch((err) => {
            this.load = false;
          });
      }
    },
    chooseVideo() {
      let video = {};
      video["id"] = this.videos[this.select].id;
      video["index"] = this.index;
      video["video"] = this.videos[this.select].video;
      if (this.question) {
        axios
          .post("/recruiters/gallery_videos", {
            video: {
              video_id: this.videos[this.select].id,
              question_id: this.question.id,
            },
          })
          .then((response) => {
            eventBus.$emit("chooseVideo", video);
            this.$emit("close");
          });
        return;
      }
      axios
        .post("/recruiters/galleries/items", {
          video: {
            video_id: this.videos[this.select].video_id,
          },
          gallery_item: {
            id: this.gallery_item.id,
            name: this.videos[this.select].name,
            description: this.gallery_item.description,
            reference_id: this.gallery_item.reference_id,
            video_id: this.videos[this.select].video_id,
          },
          galleries: {
            id: this.gallery.id,
            gallery_category_id: this.gallery.category_id,
            reference_id: this.gallery_item.reference_id,
            item_category_id: this.gallery_item.category_id,
            name: this.gallery.name,
          },
        })
        .then((response) => {
          eventBus.$emit(
            `setNewGalleryItem${this.index}`,
            response.data.gallery_item
          );
          eventBus.$emit("chooseVideo", {
            index: this.index,
            id: this.videos[this.select].id,
            video: this.videos[this.select].video,
          });
          this.$emit("close");
        });
    },
  },
};
</script>

<style>
</style>